import { Card } from "react-bootstrap";
import { NormalRadioButton } from "../NormalRadioButton";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Options = () => {
    const { t } = useTranslation();
    const [regions, setRegions] = useState(["All Regions"]);
    const [cities, setCities] = useState(["All Cities"]);
    const [selectedRegion, setSelectedRegion] = useState("All Regions");
	  const [selectedCity, setSelectedCity] = useState("All Cities");
    const [radioBtn, setRadioBtn] = useState("All Offices");
    const [allBranches, setAllBranches] = useState([]);
    const [branches, setBranches] = useState([]);

    const handlechange = (e) => {
      setRadioBtn(e.target.value);
      if (e.target.value === "All Offices") {
        if (selectedRegion !== "All Regions" && selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.area === selectedRegion && branch.city === selectedCity
          );
          setBranches(fBranches);
        } else if (selectedRegion !== "All Regions") {
          const fBranches = allBranches.filter(
            (branch) => branch.area === selectedRegion
          );
          setBranches(fBranches);
        } else if (selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) => branch.city === selectedCity
          );
          setBranches(fBranches);
        } else {
          setBranches(allBranches);
        }
      }
      if (e.target.value === "Sales Office") {
        if (selectedRegion !== "All Regions" && selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Sales Office" &&
              branch.area === selectedRegion &&
              branch.city === selectedCity
          );
          setBranches(fBranches);
        } else if (selectedRegion !== "All Regions") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Sales Office" && branch.area === selectedRegion
          );
          setBranches(fBranches);
        } else if (selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Sales Office" && branch.city === selectedCity
          );
          setBranches(fBranches);
        } else {
          const fBranches = allBranches.filter(
            (branch) => branch.type === "Sales Office"
          );
          setBranches(fBranches);
        }
      }
      if (e.target.value === "Head Office") {
        if (selectedRegion !== "All Regions" && selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Head Office" &&
              branch.area === selectedRegion &&
              branch.city === selectedCity
          );
          setBranches(fBranches);
        } else if (selectedRegion !== "All Regions") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Head Office" && branch.area === selectedRegion
          );
          setBranches(fBranches);
        } else if (selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Head Office" && branch.city === selectedCity
          );
          setBranches(fBranches);
        } else {
          const fBranches = allBranches.filter(
            (branch) => branch.type === "Head Office"
          );
          setBranches(fBranches);
        }
      }
      if (e.target.value === "Claim Office") {
        if (selectedRegion !== "All Regions" && selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Claim Office" &&
              branch.area === selectedRegion &&
              branch.city === selectedCity
          );
          setBranches(fBranches);
        } else if (selectedRegion !== "All Regions") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Claim Office" && branch.area === selectedRegion
          );
          setBranches(fBranches);
        } else if (selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.type === "Claim Office" && branch.city === selectedCity
          );
          setBranches(fBranches);
        } else {
          const fBranches = allBranches.filter(
            (branch) => branch.type === "Claim Office"
          );
          setBranches(fBranches);
        }
      }
    };
  
    const handleRegionChange = (e) => {
      setSelectedRegion(e.target.value);
      if (e.target.value === "All Regions") {
        if (radioBtn !== "All Offices" && selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) => branch.type === radioBtn && branch.city === selectedCity
          );
          setBranches(fBranches);
        } else if (radioBtn !== "All Offices") {
          const fBranches = allBranches.filter(
            (branch) => branch.type === radioBtn
          );
          setBranches(fBranches);
        } else if (selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) => branch.city === selectedCity
          );
          setBranches(fBranches);
        } else {
          setBranches(allBranches);
        }
      } else {
        if (radioBtn !== "All Offices" && selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.area === e.target.value &&
              branch.type === radioBtn &&
              branch.city === selectedCity
          );
          setBranches(fBranches);
        } else if (radioBtn !== "All Offices") {
          const fBranches = allBranches.filter(
            (branch) => branch.area === e.target.value && branch.type === radioBtn
          );
          setBranches(fBranches);
        } else if (selectedCity !== "All Cities") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.area === e.target.value && branch.city === selectedCity
          );
          setBranches(fBranches);
        } else {
          const fBranches = allBranches.filter(
            (branch) => branch.area === e.target.value
          );
          setBranches(fBranches);
        }
      }
    };

    const handleCityChange = (e) => {
      setSelectedCity(e.target.value);
      if (e.target.value === "All Cities") {
        if (radioBtn !== "All Offices" && selectedRegion !== "All Regions") {
          const fBranches = allBranches.filter(
            (branch) => branch.type === radioBtn && branch.area === selectedRegion
          );
          setBranches(fBranches);
        } else if (radioBtn !== "All Offices") {
          const fBranches = allBranches.filter(
            (branch) => branch.type === radioBtn
          );
          setBranches(fBranches);
        } else if (selectedRegion !== "All Regions") {
          const fBranches = allBranches.filter(
            (branch) => branch.area === selectedRegion
          );
          setBranches(fBranches);
        } else {
          setBranches(allBranches);
        }
      } else {
        if (radioBtn !== "All Offices" && selectedRegion !== "All Regions") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.city === e.target.value &&
              branch.type === radioBtn &&
              branch.area === selectedRegion
          );
          setBranches(fBranches);
        } else if (radioBtn !== "All Offices") {
          const fBranches = allBranches.filter(
            (branch) => branch.city === e.target.value && branch.type === radioBtn
          );
          setBranches(fBranches);
        } else if (selectedRegion !== "All Regions") {
          const fBranches = allBranches.filter(
            (branch) =>
              branch.city === e.target.value && branch.area === selectedRegion
          );
          setBranches(fBranches);
        } else {
          const fBranches = allBranches.filter(
            (branch) => branch.city === e.target.value
          );
          setBranches(fBranches);
        }
      }
    };

    return(
      <div className="container-fluid filter-card-containercustom">
      <Card className="filter-card shadow">
        <div
          className="row"
          style={{ alignContent: "center", alignItems: "center" }}
        >
          <div className="col-lg-6 tab-radio">
            <div className="dropdowncontainer d-flex">
              <select
                className="selectdropdown"
                value={selectedRegion}
                onChange={handleRegionChange}
              >
                {regions.map((region, index) => (
                  <option key={index} value={region}>
                    {region}
                  </option>
                ))}
              </select>
              <select
                className="selectdropdown "
                value={selectedCity}
                onChange={handleCityChange}
              >
                {cities.map((city, index) => (
                  <option key={index} value={city}>
                    {city}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-lg-6">
            <div
              className="row contact-radio mr-0"
              style={{ justifyContent: "space-around" }}
            >
              <div className="btn-container">
                <NormalRadioButton
                  type="radio"
                  name="All Offices"
                  value="All Offices"
                  radioValue={t("contactUs.all_offices")}
                  onChange={handlechange}
                  checked={radioBtn === "All Offices"}
                />
              </div>
              <div className="btn-container">
                <NormalRadioButton
                  type="radio"
                  name="Sales Office"
                  value="Sales Office"
                  onChange={handlechange}
                  radioValue={t("contactUs.sales_office")}
                  checked={radioBtn === "Sales Office"}
                />
              </div>
              <div className="btn-container">
                <NormalRadioButton
                  type="radio"
                  name="Head Office"
                  value="Head Office"
                  onChange={handlechange}
                  radioValue={t("contactUs.head_office")}
                  checked={radioBtn === "Head Office"}
                />
              </div>
              <div className="btn-container">
                <NormalRadioButton
                  type="radio"
                  onChange={handlechange}
                  name="Claim Office"
                  value="Claim Office"
                  radioValue={t("contactUs.claims_office")}
                  checked={radioBtn === "Claim Office"}
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
    )
}

export default Options;